<template>
  <div>

    <TitlePage :title="$t('customers')"></TitlePage>

    <v-row class="align-center">

      <v-col cols="12" md="6">
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('filterResults')" hide-details dense></v-text-field>
      </v-col>

    </v-row>


    <div class="mt-5">
      <v-data-table
          v-model="selected" :headers="headers" :items="items"
          :single-select="false" item-key="_id" show-select class="elevation-1" :search="search"
      >

        <template v-slot:item.type="{ item }">
          {{item.type}}
        </template>

        <template v-slot:item.to="{ item }">
          {{item.to}}
        </template>

        <template v-slot:item.code="{ item }">
          {{item.code}}
        </template>

        <template v-slot:item.created_at="{ item }">
          {{new Date(item.created_at).toLocaleString()}}
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon dense color="primary" class="mr-3" @click="details(item.user_id)">mdi-file-find</v-icon>
        </template>

      </v-data-table>

    </div>

  </div>

</template>

<script>

import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';
import ModalDelete from "@/components/layout/ModalDelete.vue";
import ItemActions from "@/components/layout/ItemActions.vue";

const exportService = require('@/services/export')

export default {
  name: 'Notifications',
  components: {ItemActions, ModalDelete, TitlePage},
  data() {
    return {
      search: '',
      selected: [],
      headers: [
        { text: this.$t('Id'), align: 'start', value: '_id'},
        { text: this.$t('type'), value: 'type', sortable: false},
        { text: this.$t('to'), align: 'start', value: 'to'},
        { text: this.$t('code'), align: 'start', value: 'code', sortable: false},
        { text: this.$t('actions'), align: 'start', value: 'actions', sortable: false},
      ],
      items: [],
      items_count: 0,
      pathDetails: '/customers/details/',
    };
  },
  async created(){
    await this.makeSearch()
  },
  computed: {
    ...mapGetters({
      'getUser':'user/getUser'
    }),
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),

    ...mapActions({
      'getItems': 'customers/notifications',
    }),

    async makeSearch() {
      this.setLoading(true);
      this.items = await this.getItems();
      this.setLoading(false);
    },

    details(id){
      let url = this.$router.resolve(this.pathDetails+id)
      window.open(url.href, '_blank');
    },

    async export(){
      var csv = await exportService.getCsv(this.headers, this.items)
      var encodedUri = encodeURI(csv);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `export_${new Date().toISOString()}.csv`);
      document.body.appendChild(link); // Required for FF
      link.click();
    },
  },
  mounted() {

  },
}
</script>
